import axios from "axios";

const state = {
    education: [],
};

const getters = {
    education: state => state.education,
};

const mutations = {
    setEducation: (state, education) => (state.education = education),
};

const actions = {
    async fetchEducation({commit}, params) {
        const {data} = await axios.get('/v2/education');

        commit('setEducation', data.data);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
